import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SimulationModel } from 'src/app/shared/models/simulation.model';
import { environment } from 'src/environments/environment.local';

@Injectable({
  providedIn: 'root',
})
export class SimulationService {
  constructor(private http: HttpClient) {}

  public saveSimulation(model: SimulationModel) {
    return this.http.post<SimulationModel>(`${environment.apiUrls.simulation}`, model);
  }
}
